import type { ReactElement } from 'react';
import { useTranslation } from '@govard/i18n-core/react';

import { EmptyState } from '../../../components/entity-detail/EmptyState.js';
import { EntityHistoryFeed } from '../../../components/entity-detail/EntityHistoryFeed.js';
import { describeActivity } from '../../activity/lib/describeActivity.js';
import type { ActivityItem } from '../../activity/api/activities.client.js';
import type { MeetingItem } from '../api/meetings.client.js';

/**
 * Вкладка «Обзор» карточки встречи: описание и последние события. Участники и
 * связи живут в сайдбаре — здесь их дублировать не нужно.
 */
export function MeetingOverview({
  meeting,
  history,
}: {
  meeting: MeetingItem;
  history: ActivityItem[];
}): ReactElement {
  const { t } = useTranslation();
  const historyItems = history.map((item) => ({
    id: item.id,
    text: describeActivity(item),
    date: item.occurredAt ?? item.createdAt,
  }));
  return (
    <div className="entity-overview">
      <section className="entity-panel">
        <h3>{t('crm.entity_detail.description')}</h3>
        {meeting.description ? (
          <p className="entity-note-text" style={{ whiteSpace: 'pre-wrap' }}>
            {meeting.description}
          </p>
        ) : (
          <EmptyState text={t('crm.entity_detail.empty_overview')} />
        )}
      </section>
      <section className="entity-panel">
        <h3>{t('crm.entity_detail.last_activity')}</h3>
        <EntityHistoryFeed items={historyItems.slice(0, 3)} />
      </section>
    </div>
  );
}
